var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 9 19"}},[_c('path',{staticClass:"arrow end",attrs:{"d":"M6,19 h-3 v-10 h-3 l4.5,-9 l4.5,9 h-3 v10 h-3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }